import React, { useEffect, useState } from "react";
import UserPageSection from "./Content";
import deodLogo from "../../../image/Logo.png";
import UsdtLogo from "../../../image/tether-logo.png";
import { useNavigate } from "react-router-dom";
import { ethers } from "ethers";
import Loading from "../LoaderPageSection/Loading";
import { getUserLevel } from "../../../utils/userLevels";
import { getActiveTotalStake } from "../../../utils/fetchAllActiveStakes";
import {
    OldStakeAbiFour,
    OldStakeAddressFour,
    SecondOldStakeAbiFour,
    SecondOldStakeAddressFour,
    stake5BSC,
    stake5BSCABI,
    StakeAbiFour,
    StakeAbiFourUpdate,
    StakeAbiThree,
    StakeAbiTwo,
    StakeAddressFour,
    StakeAddressFourUpdate,
    StakeAddressThree,
    StakeAddressTwo,
} from "../Abi/Content";
import axios from "axios";
import { BigNumber } from "bignumber.js";
import { useAuth } from "../../context/auth";
import { toast } from "react-toastify";
import { dummyDatas, showDeodMaintenanceAlert } from "../../../dummyData";
import { ismintedFour } from "../../../data";
import { getMaturityDate, stake5Deposits } from "../Abi/stakingDeposits";
import proofOfStakeImg from "../../../image/proof-of-stake.png";
import stakedAmountImg from "../../../image/money.png";
import tokenwallet from "../../../image/wallet.png";
import drawalImg from "../../../image/wallets2.png";
import calenderImg from "../../../image/calendar.png";
import rewardImg from "../../../image/coin.png";
import totalwithdrawnImg from "../../../image/money-bag.png";
import useDeodBalanceOf from "../../../hooks/useDeodBalanceOf";

const Userstakefive = () => {
    const navigate = useNavigate();
    const [auth, setAuth] = useAuth({});
    const [refferal, setRefferal] = useState("");
    const [address, setAddress] = useState("");
    const [owner, setOwner] = useState("");
    const [ownership, setOwnership] = useState("");
    const [loading, setLoading] = useState(false);
    const [totalToken, setTotalToken] = useState("0");
    const [totalClaimToken, setTotalClaimToken] = useState("0");
    const [availableClaim, setAvailableClaim] = useState("0");
    const [refferalEarn, setRefferalEarn] = useState("0");
    const [stackingData, setStackingData] = useState([]);
    const [stakes, setStakes] = useState([]);
    const [totalTokenStaked, setTotalTokenStaked] = useState("0");
    const [usdtPrice, setUsdtPrice] = useState(0);
    const [referralEarningsWithdrawn, setreferralEarningsWithdrawn] =
        useState(0);
    const [getUserReferalEarningV4, setgetUserReferalEarningV4] = useState(0);
    const [oldTotalToken, setoldTotalToken] = useState(0);
    const { deodBalance } = useDeodBalanceOf(stake5BSC)
    const [totalClaimTokenTwo, setTotalClaimTokenTwo] = useState("0");
    const [referralEarningsWithdrawnTwo, setreferralEarningsWithdrawnTwo] =
        useState(0);
        // active stakes
    const [allActiveStakes, setAllActiveStakes] = useState(0);
    const userLeveData = getUserLevel(totalToken);
    // console.log("userLevel", userLeveData);

    /*Switch to Testnet*/ const networkData = {
        sepolia: {
            chainId: "0xaa36a7",
            chainName: "Sepolia Testnet",
            nativeCurrency: {
                name: "Sepolia Ether",
                symbol: "ETH",
                decimals: 18,
            },
            rpcUrls: ["https://rpc.sepolia.org"],
            blockExplorerUrls: ["https://sepolia.etherscan.io"],
        },
        bnbTestnet: {
            chainId: "0x61",
            chainName: "BNB Smart Chain Testnet",
            nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
            rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545/"],
            blockExplorerUrls: ["https://testnet.bscscan.com"],
        },

        /* --- BSC MAINNET --- */
        bsc: {
            chainId: "0x38", // 56 decimal
            chainName: "BNB Smart Chain Mainnet",
            nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
            rpcUrls: ["https://bsc-dataseed.binance.org/"],
            blockExplorerUrls: ["https://bscscan.com"],
        },

        /* --- POLYGON MAINNET --- */
        polygon: {
            chainId: "0x89", // 137 decimal
            chainName: "Polygon Mainnet",
            nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
            rpcUrls: ["https://polygon-rpc.com/"],
            blockExplorerUrls: ["https://polygonscan.com"],
        },
    };
    const switchNetworks = async (networkName) => {
        const network = networkData[networkName];
        try {
            await window.ethereum.request({
                method: "wallet_switchEthereumChain",
                params: [{ chainId: network.chainId }],
            });
            console.log("network switched");
        } catch (switchError) {
            // This error code indicates that the chain has not been added to MetaMask.
            if (switchError.code === 4902) {
                try {
                    await window.ethereum.request({
                        method: "wallet_addEthereumChain",
                        params: [network],
                    });
                    console.log("network switched");
                } catch (addError) {
                    console.log(addError);
                    // handle "add" error
                }
            }
            // handle other "switch" errors
        }
    };

    const loadData = async () => {
        // debugger
        setLoading(true);
        try {
            let provider;
            if (window?.ethereum) {
                provider = window?.ethereum;
            } else if (window?.web3) {
                provider = window?.web3?.currentProvider;
            } else {
                window.alert("No ethereum browser !checkout metamask");
            }
            if (provider) {
                if (provider !== window?.ethereum) {
                    console.error(
                        "Not window.ethereum.Do you have multiple wallets installed",
                    );
                }
                await provider.request({
                    method: "eth_requestAccounts",
                });
            }
            const oldProvider = new ethers.providers.Web3Provider(
                window.ethereum,
            );
            const network = await oldProvider.getNetwork();
            await switchNetworks("bsc");
            const newProvider = new ethers.providers.Web3Provider(
                window?.ethereum,
            );
            const signer = newProvider.getSigner();
            const currentaccount = await signer.getAddress();
            const address = currentaccount.toLowerCase();
            // const address = ('0x3F7B1B1849607F184DFC445041198F2df64253FF').toLowerCase();
            const StakeContract = new ethers.Contract(
                stake5BSC,
                stake5BSCABI,
                signer,
            );
            const owner = await StakeContract.owner();
            setOwner(owner);
            const allStakes = await getActiveTotalStake(address, stake5BSC, 5);
            // console.log("activeStakes:", allStakes);
            setAllActiveStakes(allStakes);
            const totalStaked =
                await StakeContract.userTotalTokenStakedV5(address);
            setTotalToken(ethers.utils.formatEther(totalStaked));
            const totalTokenStakedAdmin =
                await StakeContract.totalTokensStakedOfV5();
            setTotalTokenStaked(
                ethers.utils.formatEther(totalTokenStakedAdmin),
            );
            const referralEarnings =
                await StakeContract.referralEarnings(address);
            setRefferalEarn(ethers.utils.formatEther(referralEarnings));
            const availableClaim =
                await StakeContract.availableReleaseAmount(address);
            setAvailableClaim(ethers.utils.formatEther(availableClaim));
            const withdrawnAmount =
                await StakeContract.withdrawnAmountV5(address);
            setTotalClaimToken(ethers.utils.formatEther(withdrawnAmount));
        } catch (error) {
            console.log("loadBlockchainData", error);
        }
        setLoading(false);
    };
    const filteredDeposits = stake5Deposits.filter(
        (item) => item.alloteeAddress.toLowerCase() === address.toLowerCase(),
    );
    const handleGetStackingData = async () => {
        const token = auth?.user?.token;
        const headers = {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can adjust this as needed
        };
        try {
            const resp = await axios.get(`/api/v5/user/stakeV5details`, {
                headers,
            });
            if (resp.status === 200) {
                if (resp?.data?.status === true) {
                    setStackingData(resp?.data?.data);
                } else {
                    toast.error("Error", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            } else {
                toast.error("Error", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            if (error.response.status === 400) {
                var err_400 = error?.response?.data?.message;
                toast.error(err_400);
            } else if (error.response.status === 401) {
                const err_401 = error?.response?.data?.message;
                toast.error(err_401);
            } else if (error.response.status === 404) {
                const err_404 = error?.response?.data?.message;
                toast.error(err_404);
            } else if (error.response.status === 500) {
                const err_500 = error?.response?.data?.message;
                toast.error(err_500);
            } else {
                console.log("Error in Register", error);
                toast.error("something went wrong");
            }
        }
    };
    function timestampToDate(seconds) {
        const date = new Date(seconds * 1000); // Convert to milliseconds
        return date.toLocaleString(); // Example: "6/30/2025, 7:45:12 PM"
    }
    const handleClaimAPI = async (trxHash) => {
        const token = auth?.user?.token;
        const headers = {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // You can adjust this as needed
        };

        const bodyData = {
            amount: availableClaim,
            transactionHash: trxHash,
        };
        try {
            const resp = await axios.post(
                `/api/v5/user/stakeV5Withdrawal`,
                bodyData,
                {
                    headers,
                },
            );
            if (resp.status === 200) {
                if (resp?.data?.status === true) {
                    toast.success(resp?.data?.message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    window.location.reload(false);
                } else {
                    toast.error("Error", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            } else {
                toast.error("Error", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            if (error.response.status === 400) {
                var err_400 = error?.response?.data?.message;
                toast.error(err_400);
            } else if (error.response.status === 401) {
                const err_401 = error?.response?.data?.message;
                toast.error(err_401);
            } else if (error.response.status === 404) {
                const err_404 = error?.response?.data?.message;
                toast.error(err_404);
            } else if (error.response.status === 500) {
                const err_500 = error?.response?.data?.message;
                toast.error(err_500);
            } else {
                console.log("Error in Register", error);
                toast.error("something went wrong");
            }
        }
    };

    const handleClaim = async () => {
        setLoading(true);
        try {
            let provider;
            if (window.ethereum) {
                provider = window.ethereum;
            } else if (window.web3) {
                provider = window.web3.currentProvider;
            } else {
                window.alert("No ethereum browser !checkout metamask");
            }
            if (provider) {
                if (provider !== window.ethereum) {
                    console.error(
                        "Not window.ethereum.Do you have multiple wallets installed",
                    );
                }
                await provider.request({
                    method: "eth_requestAccounts",
                });
            }
            const newProvider = new ethers.providers.Web3Provider(
                window.ethereum,
            );
            const signer = newProvider.getSigner();
            const currentaccount = await signer.getAddress();
            const address = currentaccount.toLowerCase();
            const storeAddress = auth?.user?.address;
            if (address === storeAddress) {
                const StakeContract = new ethers.Contract(
                    stake5BSC,
                    stake5BSCABI,
                    signer,
                );
                const txn =
                    await StakeContract.withdrawRecurringReleaseTokens(address);
                const receipttxn1 = await txn.wait();
                if (receipttxn1.status !== 1) {
                    toast.error("Error");
                } else {
                    const hash = await receipttxn1.transactionHash;
                    //   await handleClaimAPI(hash);
                    alert("claim Successful");
                    window.location.reload(false);
                }
            } else {
                toast.error("Connect correct wallet");
            }
        } catch (error) {
            console.log("loadBlockchainData", error);
            toast.error(`${JSON.stringify(error?.reason || error?.message)}`, {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
        setLoading(false);
    };
    const transferOwnership = async () => {
        try {
            const newProvider = new ethers.providers.Web3Provider(
                window?.ethereum,
            );
            const signer = newProvider.getSigner();
            const currentaccount = await signer.getAddress();
            // const address = ('0xe67f2a68dA7A47A944f5d56A76c5e03aE1c71959').toLowerCase();
            const address = currentaccount.toLowerCase();
            const StakeContract = new ethers.Contract(
                stake5BSC,
                stake5BSCABI,
                signer,
            );
            const withdraw = await StakeContract.transferOwnership(ownership);
            const rcpt = await withdraw.wait();
            alert("Transfer Ownership Successful");
        } catch (error) {
            console.log(error);
            alert(error.message);
        }
    };
    const handleClaimReferral = async () => {
        setLoading(true);
        try {
            let provider;
            if (window.ethereum) {
                provider = window.ethereum;
            } else if (window.web3) {
                provider = window.web3.currentProvider;
            } else {
                window.alert("No ethereum browser !checkout metamask");
            }
            if (provider) {
                if (provider !== window.ethereum) {
                    console.error(
                        "Not window.ethereum.Do you have multiple wallets installed",
                    );
                }
                await provider.request({
                    method: "eth_requestAccounts",
                });
            }
            const newProvider = new ethers.providers.Web3Provider(
                window.ethereum,
            );
            const signer = newProvider.getSigner();
            const currentaccount = await signer.getAddress();
            const address = currentaccount.toLowerCase();
            const storeAddress = auth?.user?.address;
            if (address === storeAddress) {
                const StakeContract = new ethers.Contract(
                    stake5BSC,
                    stake5BSCABI,
                    signer,
                );
                const txn = await StakeContract.claimReferralEarnings();
                const receipttxn1 = await txn.wait();
                if (receipttxn1.status !== 1) {
                    toast.error("Error");
                } else {
                    const hash = await receipttxn1.transactionHash;
                    // await handleClaimAPI(hash);
                    alert("Claim Successfully");
                    window.location.reload(false);
                }
            } else {
                toast.error("Connect correct wallet");
            }
        } catch (error) {
            console.log("loadBlockchainData", error);
            toast.error(`${JSON.stringify(error?.reason || error?.message)}`, {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
        setLoading(false);
    };
    const handleEmergencyWithdraw = async () => {
        try {
            const newProvider = new ethers.providers.Web3Provider(
                window?.ethereum,
            );
            const signer = newProvider.getSigner();
            const currentaccount = await signer.getAddress();
            // const address = ('0xe67f2a68dA7A47A944f5d56A76c5e03aE1c71959').toLowerCase();
            const address = currentaccount.toLowerCase();
            const StakeContract = new ethers.Contract(
                stake5BSC,
                stake5BSCABI,
                signer,
            );
            const withdraw = await StakeContract.emergencyWithdraw();
            const rcpt = await withdraw.wait();
            alert("Emergency Token Withdrawn");
        } catch (error) { }
    };
    useEffect(() => {
        async function handleGetParaswapPrice() {
            if (totalToken == 0) {
                setUsdtPrice(0);
            } else {
                try {
                    let x;
                    x = totalToken * 10 ** 18;
                    let z = new BigNumber(x);
                    let a = z.toFixed();
                    const Paraswap = `https://backend.decentrawood.com/commonAPI/getDeodPrice`;
                    console.log("Paraswap", a);
                    const getParaswapData = await axios.get(Paraswap);
                    console.log("getParaswapData", getParaswapData);
                    if (getParaswapData.status === 200) {
                        let finalUSDTPrice =
                            getParaswapData?.data?.data?.priceRoute?.destAmount;
                        finalUSDTPrice = (finalUSDTPrice / 10 ** 18).toFixed(2);

                        setUsdtPrice((totalToken / finalUSDTPrice).toFixed(2));
                    }
                } catch (error) {
                    console.log("error in deod price paraswap api", error);
                }
            }
        }
        handleGetParaswapPrice();
    }, [totalToken]);

    useEffect(() => {
        async function handleData() {
            await loadData();
        }
        handleData();
    }, []);

    useEffect(() => {
        if (
            auth?.user?.address &&
            auth?.user?.referralAddress &&
            auth?.user?.token
        ) {
            setRefferal(auth?.user?.referralAddress);
            setAddress(auth?.user?.address);
            // setAddress(`0xd4068cf47D8EEFf33217d7926aE38bf066f738E4`.toLowerCase());
            handleGetStackingData();
        }
    }, [auth]);

    return (
        <div>
            <UserPageSection>
                {loading && <Loading loading={loading} text={"Loading..."} />}
                <h1 className="text-white f-bold mb-2" style={{}}>Welcome back <span style={{ color: "#e87722ff", textTransform: "capitalize", fontWeight: "bold", }}>{userLeveData?.name ? `${userLeveData?.name}` : ''}</span> <img style={{ width: "auto", height: "40px" }} src={userLeveData?.image} alt={userLeveData?.name} /></h1>
                <div>
                    {/* Top Row — 5 Column Grid */}
                    <div className="dashboard-cards-grid">
                        {/* Card 1: Staked Assets */}
                        <div className="dashboard-card">
                            <div className="dashboard-card-header">
                                <span className="dashboard-card-title">
                                   Token Staked
                                </span>
                                <div className="card-custom-icon">
                                    <img
                                        src={proofOfStakeImg}
                                        alt="proof-of-stake"
                                        style={{
                                            width: "70px",
                                            height: "50px",
                                            marginTop: "-5%",
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="dashboard-card-value">
                                {allActiveStakes.toFixed(2)}
                            </div>
                            <div className="dashboard-card-subtitle">DEOD</div>
                            {/* <div className="dashboard-card-subtitle" style={{ color: "#e87722ff", fontWeight: "bold" }}>
                                Active Stakes: {allActiveStakes} DEOD
                            </div> */}
                        </div>

                        {/* Card 2: Staked Amount (USDT value) */}
                        {/* <div className="dashboard-card">
                            <div className="dashboard-card-header">
                                <span className="dashboard-card-title">Staked Amount</span>
                                <div className="card-custom-icon">
                                    <i className="bi bi-coin" style={{ color: '#f5841f' }}></i>
                                </div>
                            </div>
                            <div className="dashboard-card-value">{usdtPrice}</div>
                            <div className="dashboard-card-subtitle">USDT Value</div>
                            </div> */}

                        <div className="dashboard-card">
                            <div className="dashboard-card-header">
                                <span className="dashboard-card-title">
                                    Available Withdrawal
                                </span>
                                <div className="card-custom-icon">
                                    <img
                                        src={drawalImg}
                                        alt="proof-of-stake"
                                        style={{
                                            width: "70px",
                                            height: "50px",
                                            marginTop: "-5%",
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="dashboard-card-value">
                                {availableClaim}
                            </div>
                            <div className="dashboard-card-subtitle">
                                24 Feb-2026 Onwards
                            </div>
                            <button
                                className="claim-btn"
                                onClick={() => handleClaim()}
                                style={{ marginTop: "12px" }}
                            >
                                Claim
                            </button>
                        </div>

                        <div className="dashboard-card card-large">
                            <div className="dashboard-card-header">
                                <span className="dashboard-card-title">
                                    Staked Token Value
                                </span>
                                <div className="dashboard-card-icon card-icon-blue">
                                    <img
                                        src={tokenwallet}
                                        alt="proof-of-stake"
                                        style={{
                                            width: "50px",
                                            height: "50px",
                                            marginTop: "-5%",
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="dashboard-card-value">
                                ${usdtPrice}{" "}
                            </div>
                            <div className="card-stats-row">
                                <div className="card-stat-item">
                                    <div className="card-stat-label">
                                        Tokens Staked
                                    </div>
                                    <div
                                        className="card-stat-value"
                                        style={{ color: "#f5841f" }}
                                    >
                                        {totalToken} DEOD
                                    </div>
                                </div>
                                <div className="card-stat-item">
                                    <div className="card-stat-label">
                                        Referral Earnings
                                    </div>
                                    <div
                                        className="card-stat-value"
                                        style={{ color: "#f5841f" }}
                                    >
                                        {refferalEarn} DEOD
                                    </div>
                                </div>
                            </div>
                            {/* <button
                                className="claim-btn-outline"
                                onClick={() => handleClaim()}
                            >
                                Claim Principal
                            </button> */}
                        </div>

                        {/* Card 2: Total Withdrawal */}
                        <div className="dashboard-card">
                            <div className="dashboard-card-header">
                                <span className="dashboard-card-title">
                                    Total Withdrawal
                                </span>
                                <div className="card-custom-icon">
                                    <img
                                        src={totalwithdrawnImg}
                                        alt="proof-of-stake"
                                        style={{
                                            width: "70px",
                                            height: "50px",
                                            marginTop: "-5%",
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="dashboard-card-value">
                                {+oldTotalToken +
                                    +totalClaimToken +
                                    +referralEarningsWithdrawn +
                                    +totalClaimTokenTwo +
                                    +referralEarningsWithdrawnTwo}
                            </div>
                            <div className="dashboard-card-subtitle">DEOD</div>
                        </div>

                        {/* Card 3: Staked Token Value — Large Card */}

                        {/* Card 4: Staked Period (Mock/Constant as in Stake 2/3) */}
                        {/* <div className="dashboard-card">
                            <div className="dashboard-card-header">
                                <span className="dashboard-card-title">Staked Period</span>
                                <div className="card-custom-icon">
                                    <i className="bi bi-calendar3" style={{ color: '#f5841f' }}></i>
                                </div>
                            </div>
                            <div className="dashboard-card-value">V5 Term</div>
                            <div className="dashboard-card-subtitle">Staking Period</div>
                            </div> */}

                        {/* Card 5: Available Release — Referral Earnings Summary card equivalent */}
                        <div className="dashboard-card">
                            <div className="dashboard-card-header">
                                <span className="dashboard-card-title">
                                    Available Release
                                </span>
                                <div className="card-custom-icon">
                                    <i
                                        className="bi bi-clock-history"
                                        style={{ color: "#f5841f" }}
                                    ></i>
                                </div>
                            </div>
                            <div className="dashboard-card-value">
                                {refferalEarn}
                            </div>
                            <div className="dashboard-card-subtitle">
                                Till 23 Feb-2026
                            </div>
                            <button
                                className="claim-btn"
                                onClick={() => handleClaimReferral()}
                                style={{ marginTop: "12px" }}
                            >
                                Claim
                            </button>
                        </div>
                    </div>

                    <div className="dashboard-card mb-4">
                        <div className="dashboard-card-header">
                            <span className="dashboard-card-title">
                                Global Pool Stats
                            </span>
                            <div className="card-custom-icon">
                                <i
                                    className="bi bi-bank"
                                    style={{
                                        color: "#f5841f",
                                        fontSize: "1.2rem",
                                    }}
                                ></i>
                            </div>
                        </div>
                        <div className="dashboard-card-value" style={{ color: "#f5841f", }}>
                            {Number(deodBalance || 0).toFixed(2)} DEOD
                        </div>
                        <div className="dashboard-card-subtitle mt-2">Total DEOD Staked Globally</div>
                    </div>

                    {/* Ownership Transfer — Only visible to owner/admin */}
                    {(address.toLowerCase() ===
                        `0x7f967ec284cE3E3E3503C19dB74dc697aEa4c0F2`.toLowerCase() ||
                        address.toLowerCase() === owner.toLowerCase()) && (
                            <div
                                className="dashboard-cards-row-2"
                                style={{ marginBottom: 28 }}
                            >
                                <div className="dashboard-card">
                                    <div className="dashboard-card-header">
                                        <span className="dashboard-card-title">
                                            Ownership Transfer
                                        </span>
                                        <div className="dashboard-card-icon card-icon-purple">
                                            <i className="bi bi-shield-lock-fill"></i>
                                        </div>
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="Eg. 0x0123..321"
                                        style={{
                                            width: "100%",
                                            padding: "10px 14px",
                                            background: "rgba(255,255,255,0.05)",
                                            border: "1px solid rgba(255,255,255,0.12)",
                                            borderRadius: "10px",
                                            color: "#fff",
                                            fontSize: "13px",
                                            outline: "none",
                                            marginTop: "12px",
                                            fontFamily: "'Inter', sans-serif",
                                        }}
                                        value={ownership}
                                        onChange={(e) =>
                                            setOwnership(e.target.value)
                                        }
                                    />
                                    <button
                                        className="claim-btn"
                                        onClick={() => transferOwnership()}
                                        style={{ marginTop: "12px" }}
                                    >
                                        Transfer Ownership
                                    </button>
                                </div>
                            </div>
                        )}

                    {/* Staking History Table */}
                    <div className="dashboard-table-wrapper">
                        <table className="dashboard-table">
                            <thead>
                                <tr>
                                    <th>No.</th>
                                    <th>Staked Amount</th>
                                    <th>Monthly Bonus Amount</th>
                                    <th>Percentage</th>
                                    <th>Staking Date</th>
                                    <th>Release Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredDeposits &&
                                    filteredDeposits?.map((value, key) => {
                                        return (
                                            <tr key={key}>
                                                <td>{key + 1}</td>
                                                <td>
                                                    {
                                                        +ethers.utils.formatEther(
                                                            value?.depositedAmount,
                                                        )
                                                    }
                                                </td>
                                                <td>
                                                    {+ethers.utils.formatEther(
                                                        value?.depositedAmount,
                                                    ) *
                                                        (+value?.releasePercentage /
                                                            1000)}
                                                </td>
                                                <td>
                                                    {+value?.releasePercentage /
                                                        10}
                                                    %
                                                </td>
                                                <td>
                                                    {timestampToDate(
                                                        value?.OldDepositTimestamp,
                                                    )}
                                                </td>
                                                <td>
                                                    {timestampToDate(
                                                        value?.maturityTimestamp,
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </UserPageSection>
        </div>
    );
};

export default Userstakefive;
